export const darkMode = {
  body: '#000000',
  text: '#FFFFFF',
};

export const lightMode = {
  body: '#FFFFFF',
  text: '#141414',
};
